import React from "react";
import { theme } from "../../theme";

/**
 * Empty state component for displaying when no data is available
 * @param {string} message - Message to display
 * @param {string} icon - Emoji or icon to display
 * @param {string} actionText - Optional action button text
 * @param {function} onAction - Optional action button handler
 */
const EmptyState = ({
  message = "No data available",
  icon = "",
  actionText = null,
  onAction = null,
  size = "large"
}) => {
  const iconSize = size === "large" ? "64px" : "48px";
  const fontSize = size === "large" ? "18px" : "16px";

  return (
    <div
      style={{
        textAlign: "center",
        padding: theme.spacing["3xl"] + " " + theme.spacing.lg,
        color: theme.colors.text.muted,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
      }}
    >
      <div
        style={{
          fontSize: iconSize,
          marginBottom: theme.spacing.md,
          opacity: 0.7,
        }}
      >
        {icon}
      </div>
      <p
        style={{
          fontSize: fontSize,
          color: theme.colors.text.secondary,
          marginBottom: actionText ? theme.spacing.md : 0,
          maxWidth: "400px",
          lineHeight: "1.5",
        }}
      >
        {message}
      </p>
      {actionText && onAction && (
        <button
          onClick={onAction}
          style={{
            marginTop: theme.spacing.md,
            padding: theme.spacing.sm + " " + theme.spacing.lg,
            background: theme.colors.primary,
            color: theme.colors.text.primary,
            border: "none",
            borderRadius: theme.borderRadius.md,
            cursor: "pointer",
            fontSize: theme.typography.fontSize.base,
            fontWeight: theme.typography.fontWeight.medium,
            transition: theme.transitions.normal,
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = "0.9";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = "1";
            e.target.style.transform = "translateY(0)";
          }}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
